// @flow

import React from 'react';

const Product = ({ product, menuInfo }) => {
  return <div className="menu-part-category-product">{product.name}</div>;
};

export default Product;
